import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import * as Styled from "./release-notes.style";
export var ReleaseNotes = function (_a) {
    var releaseNotes = _a.releaseNotes;
    return (_jsx(_Fragment, { children: releaseNotes.map(function (note) { return (_jsxs(Styled.ReleaseNote, { children: [_jsx(Styled.Date, { children: note.date }), note.changes.map(function (change, i) { return (_jsx("p", { children: change }, note.id + i)); })] }, note.id)); }) }));
};
export var ReleaseNotesContainer = function (_a) {
    var children = _a.children;
    return (_jsx(Styled.ReleaseNotesContainer, { children: children }));
};
